import { Places } from '../../../interfaces';
import {
  LocalActionType,
  LocalTypes,
  SET_LOCAIS,
  SET_LOADING,
  SET_LOADING_BY_ID,
  SET_LOCAL_DATA_BY_ID,
  SET_CLEAR_LOCAL_DATA_BY_ID,
  SET_CREATED_LOCAL_SUCCESS,
} from './types';

export function requestGetLocais(): LocalActionType {
  return {
    type: LocalTypes.LOCAIS_REQUEST,
  };
}

export function requestGetLocalById(payload: string) : LocalActionType {
  return {
    type: LocalTypes.LOCAL_REQUEST_BY_ID,
    payload,
  };
}

export function createLocalAction(payload: any): LocalActionType {
  return {
    type: LocalTypes.CREATE_LOCAL,
    payload,
  };
}

export function updateLocalAction(payload: any, id: string): LocalActionType {
  return {
    type: LocalTypes.UPDATE_LOCAL,
    payload: { payload, id },
  };
}

export function requestFailure(payload: string): LocalActionType {
  return {
    type: LocalTypes.LOCAIS_REQUEST_FAILURE,
    payload,
  };
}

export function
setLocaisAction(payload: Array<Places>): LocalActionType {
  return {
    payload,
    type: SET_LOCAIS,
  };
}

export function setLoading(payload: boolean): LocalActionType {
  return {
    payload,
    type: SET_LOADING,
  };
}

export function
setLocalById(payload: any): LocalActionType {
  return {
    payload,
    type: SET_LOCAL_DATA_BY_ID,
  };
}

export function setCleanLocalById(): LocalActionType {
  return {
    type: SET_CLEAR_LOCAL_DATA_BY_ID,
  };
}

export function setCleanLocalScreen(payload: boolean): LocalActionType {
  return {
    type: SET_CREATED_LOCAL_SUCCESS,
    payload,
  };
}

export function setLoadingById(payload: boolean): LocalActionType {
  return {
    payload,
    type: SET_LOADING_BY_ID,
  };
}
